import apiHttp from './apiHttp';
import apiLogin from './apiLogin';
import request from './axiosFun';
// 登录
var url = '';
if (process.env.NODE_ENV === 'development') {
  url = '/est';
} else {
  url = '';
}
// 根据用户id，项目id 查询用户开通项目
export function login(query, token) {
  console.log(token, 'token');
  return apiLogin({
    url: url + '/auth/oauth2/token?grant_type=password',
    method: 'post',
    headers: {
      Authorization: 'Basic ' + token,
      contentType: 'application/x-www-form-urlencoded'
    },
    data: query
  });
}
// 验证码登录
export function loginCode(query, token) {
  return apiLogin({
    url: url + '/auth/oauth2/token?grant_type=mobile&mobile=APP-SMS@' + query.mobile + '&code=' + query.code,
    method: 'post',
    headers: {
      Authorization: 'Basic ' + token,
      contentType: 'application/x-www-form-urlencoded'
    },
    data: JSON.stringify({
      scope: query.scope
    })
  });
}
// export function getUserOpen(query) {
//   return apiHttp({
//     url: url + '/loginCore/getUserAppInfo',
//     method: 'post',
//     data: query
//   })
// }
// 获取秘钥
export function getSecret(query) {
  return apiHttp({
    url: url + '/base-server/loginInfo/getSecret/web',
    method: 'post',
    data: query
  });
}

// 获取用户项目
export function getUserAppInfo(query) {
  query.clientType = 'pc';
  return apiHttp({
    url: url + '/base-server/loginCore/getUserAppInfo',
    method: 'post',
    data: query
  });
}
// 获取用户基本信息
export function getUserBaseInfo(query) {
  return apiHttp({
    url: url + '/base-server/loginCore/getUserBaseInfo',
    method: 'post',
    data: query
  });
}

/*
  name: （新智慧养殖）金鸡滩
*/
// 判断是否显示动态菜单（智慧养殖）
export function getZhyzDynamicMenuSign(query) {
  return apiHttp({
    url: url + '/base-server/loginCore/getZhyzDynamicMenuSign?farmId=' + query,
    method: 'get'
  });
}
// 养殖场用户列表（智慧养殖）
export function getUsersByFarmId(query) {
  return request({
    url: url + '/pasture/zhyzUser/getUsersByFarmId',
    method: 'post',
    data: query
  });
}
// 新增用户
export function saveFarmUserInfo(query) {
  return request({
    url: url + '/pasture/zhyzUser/saveFarmUserInfo',
    method: 'post',
    data: query
  });
}
// 编辑用户
export function updateFarmUserInfo(query) {
  return request({
    url: url + '/pasture/zhyzUser/updateFarmUserInfo',
    method: 'post',
    data: query
  });
}
// 删除用户
export function deleteFarmUserInfo(query) {
  return request({
    url: url + '/pasture/zhyzUser/deleteFarmUserInfo',
    method: 'post',
    data: query
  });
}
// 养殖场角色列表（智慧养殖）
export function getRolesByFarmId(query) {
  return request({
    url: url + '/pasture/zhyzUser/getRolesByFarmId',
    method: 'post',
    data: query
  });
}
// 新增角色
export function saveFarmRoleInfo(query) {
  return apiHttp({
    url: url + '/pasture/zhyzUser/saveFarmRoleInfo',
    method: 'post',
    data: query
  });
}
// 编辑角色
export function updateFarmRoleInfo(query) {
  return apiHttp({
    url: url + '/pasture/zhyzUser/updateFarmRoleInfo',
    method: 'post',
    data: query
  });
}
// 删除角色
export function deleteFarmRoleInfo(query) {
  return apiHttp({
    url: url + '/pasture/zhyzUser/deleteFarmRoleInfo',
    method: 'post',
    data: query
  });
}



// WEBPACK FOOTER //
// ./src/api/login.js